import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

// Header shown across the gated app. Brand mark is a placeholder until Scott
// supplies TXCFI logo/palette. Includes the admin link (only for admins) and
// sign-out.
export default function AppHeader() {
  const { user, isAdmin, signOut } = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate("/login", { replace: true });
  }

  return (
    <header className="border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4">
        <Link to="/app" className="flex items-center gap-2">
          <span className="rounded bg-txcfi-accent px-2 py-1 text-xs font-bold uppercase tracking-wide text-white">
            TXCFI
          </span>
          <span className="text-sm font-semibold text-txcfi-ink">
            210 Ground School
          </span>
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          {isAdmin && (
            <Link
              to="/admin"
              className="font-medium text-txcfi-accent hover:underline"
            >
              Admin
            </Link>
          )}
          {user?.email && (
            <span className="hidden text-slate-500 sm:inline">
              {user.email}
            </span>
          )}
          <button
            onClick={handleSignOut}
            className="rounded-md border border-slate-300 px-3 py-1.5 font-medium text-slate-700 hover:bg-slate-50"
          >
            Sign out
          </button>
        </nav>
      </div>
    </header>
  );
}
